import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import themeNameReducer from './themeNameSlice'
import domainReducer from './domainSlice'
import commonDataReducer from './commonDataSlice'
import addressReducer from './addressSlice'

const store = configureStore({
  reducer: {
    auth: authReducer,
    themeName: themeNameReducer,
    domain: domainReducer,
    commonData: commonDataReducer,
    address: addressReducer,
  },
})

export default store
